<template>
  <div class="home">
    <div class="home-page">
      <head-form></head-form>
      <div class="section">
        <categories-section></categories-section>
      </div>
      <transfer-section></transfer-section>
      <div class="section">
        <renta-car-section></renta-car-section>
      </div>
      <limo-service-section></limo-service-section>
    </div>
  </div>
</template>

<script>
import CategoriesSection from "@/sections/Categories.vue";
import RentaCarSection from "@/sections/RentaCar.vue";
import TransferSection from "@/sections/Transfer.vue";
import HeadForm from "@/sections/HeadForm.vue";
import LimoServiceSection from "@/sections/LimoService.vue";

export default {
  name: 'Home-Page',
  components: { HeadForm, LimoServiceSection, RentaCarSection, CategoriesSection, TransferSection},
  data() {
    return {
      isMobile: false,
    }
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

body {
  font-family: 'Inter', sans-serif;
}

.home-page {
  background-color: $darker-blue;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  overflow-x: hidden;
  overflow-y: hidden;
}

.section {
  width: 70%;
  @media (max-width: 1599px) {
    width: 90%;
  }
}

</style>
